export default function (store, { dragItemId, overAreaId, before }) {
    const { areasMeta, cardsMeta, dropAreasCoords, layout, selected } = store.getState();
    dropAreasCoords?.forEach(area => {
        if (area.id) {
            areasMeta[area.id].height =
                layout !== "default:lazy" ? area.height : null;
        }
    });
    const draggedCards = selected ? [...selected] : [dragItemId];
    draggedCards.forEach(id => {
        const meta = cardsMeta[id] || {};
        meta.dragging = true;
        cardsMeta[id] = meta;
    });
    store.setState({
        dragItemId,
        dragItemAreaId: overAreaId,
        overAreaId,
        before,
        areasMeta,
        cardsMeta,
    });
}
//# sourceMappingURL=start.js.map